import { data } from 'autoprefixer';
import axios from 'axios';
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

const listAllLearninghub = async (filter, key = '', offset) => {
  console.log('Filter: ', filter);
  const apiUrl = process.env.VUE_APP_API_URL;
  const blogs = await axios
    .get(
      `${apiUrl}/v1/public/learning-hubs?filter=${filter}&q=${key}&offset=${offset}`
    )
    .then((response) => {
      return {
        status: response.status,
        data: response.data.data,
      };
    });
    console.log("LearningHub data", blogs)
  return blogs;
};

const showLearninghubDetail = async (id) => {
  const apiUrl = process.env.VUE_APP_API_URL;
  const blogDetail = await axios
    .get(`${apiUrl}/v1/public/learning-hubs/${id}`)
    .then((response) => {
        
      return {
        status: response.status,
        data: response.data.data,
      };
    });
    console.log(blogDetail);
  return blogDetail;
};

const createNewsletter = async (newsletter) => {
  const apiUrl = process.env.VUE_APP_API_URL;
  const response = await axios.post(
    `${apiUrl}/v1/public/crms?source=Learning Hub`, // Changed to "White paper"
    {
      email: newsletter.email,
      firstName: newsletter.firstName,
      lastName: newsletter.lastName,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-Page-Route': window.location.pathname,
        'X-Page-Title': document.title,
      },
    }
  );
  return response;
};

const getLearninghubVideoLink = async (slug, { email, firstName, lastName }) => {

  console.log("Slug: ", slug)
  const apiUrl = process.env.VUE_APP_API_URL;
  const response = await axios.post(
    `${apiUrl}/v1/public/learning-hubs/${slug}/video`,
    {
      email,
      firstName,
      lastName,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  console.log(data)
  return {
    status: response.status,
    data: response.data.data,
  };
};

export default {
  listAllLearninghub,
  showLearninghubDetail,
  createNewsletter,
  getLearninghubVideoLink,
};
